import { useToast } from '@chakra-ui/react';
import { useState } from 'react';

import { Draft } from '../../components/RequestDrafts/types';
import { trpc } from '../../config/trpc';

/** Hard-delete a non-actionable draft (measurement record with no apply path). */
export const useDeleteDraft = (draft: Draft | undefined, onResolved: () => void): [() => Promise<void>, boolean] => {
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteDraft = trpc.deleteRequestDraft.useMutation();

  const remove = async () => {
    if (!draft) return;
    setIsDeleting(true);
    try {
      await deleteDraft.mutateAsync({ id: draft.id });
      toast({ title: 'Draft deleted', status: 'success' });
      onResolved();
    } catch (error) {
      toast({ title: 'Error', description: error?.message, status: 'error' });
    } finally {
      setIsDeleting(false);
    }
  };

  return [remove, isDeleting];
};
